import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Megaphone } from "lucide-react";
import { api, useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../components/ui/dialog";
import { AnnonceTypeBadge } from "../pages/MisesAJour";

export default function AnnoncesPopup() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [annonces, setAnnonces] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!user) return;
    api.get("/annonces/non-lues").then((r) => setAnnonces(r.data.annonces)).catch(() => setAnnonces([]));
  }, [user]);

  useEffect(() => {
    if (annonces?.length) setOpen(true);
  }, [annonces]);

  if (!user || !annonces || annonces.length === 0) return null;

  const fermer = () => {
    const ids = annonces.map((a) => a.id);
    setOpen(false);
    // Laisser l'animation de sortie du dialogue se terminer avant de démonter (évite le crash Safari mobile "NotFoundError")
    window.setTimeout(() => setAnnonces([]), 300);
    api.post("/annonces/vues", { ids }).catch(() => { /* réapparaîtra à la prochaine connexion */ });
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) fermer(); }}>
      <DialogContent className="max-w-lg" data-testid="annonces-popup">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Megaphone className="h-5 w-5 text-accent" /> Quoi de neuf ?</DialogTitle>
          <DialogDescription>{annonces.length} mise(s) à jour du site depuis votre dernière visite</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 max-h-[55vh] overflow-y-auto py-1 pr-1" data-testid="annonces-popup-list">
          {annonces.map((a) => (
            <div key={a.id} className="rounded-lg border border-border p-3 space-y-1" data-testid={`annonce-popup-${a.id}`}>
              <div className="flex items-center gap-2">
                <AnnonceTypeBadge type={a.type} />
                <span className="text-xs font-mono text-muted-foreground">{a.date}</span>
              </div>
              <p className="text-sm font-semibold">{a.titre}</p>
              {a.description && <p className="text-xs text-muted-foreground leading-relaxed">{a.description}</p>}
            </div>
          ))}
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => { navigate("/mises-a-jour"); fermer(); }} data-testid="annonces-popup-voir-page">
            Voir la page Mises à jour
          </Button>
          <Button onClick={fermer} data-testid="annonces-ne-plus-afficher">Ne plus afficher</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
